import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogClose } from '@angular/material/dialog';
import { ZDialogComponent } from '../z-dialog/z-dialog.component';
import { ZInputComponent } from '../z-input/z-input.component';
import { ZButtonComponent } from '../z-button/z-button.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-edit-email-dialog',
    templateUrl: './edit-email-dialog.component.html',
    styleUrl: './edit-email-dialog.component.scss',
    imports: [ZDialogComponent, ZInputComponent, ZButtonComponent, MatDialogClose, TranslatePipe]
})
export class EditEmailDialog {
  email: FormControl<string> = new FormControl();

  constructor(
    public dialogRef: MatDialogRef<EditEmailDialog>,
    @Inject(MAT_DIALOG_DATA) public name: string
  ) {}

  send(): void {
    this.dialogRef.close(this.email)
  }
}
